import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import StorePresenter from '../../../presenters/StorePresenter';
import { StoreProvider } from '../../../components';

import BrandInfo from './components/BrandInfo';

export const BrandShowView = (props) => {
  const { brand, match } = props;

  const offers = brand.offers.edges.map((e) => e.node);

  return (
    <div>
      <BrandInfo brand={brand} offers={offers} match={match} />
    </div>
  );
};

const BrandShowContainer = createFragmentContainer(BrandShowView, {
  brand: graphql`
    fragment BrandShow_brand on Store {
      id
      name
      phoneNumber
      storeNumber
      defaultCashbackRate
      birthdayCashbackRate
      uniqueInState
      fastCashEnabled
      normalOpeningHour
      normalClosingHour
      sundayOpeningHour
      sundayClosingHour
      customerServiceEmail
      isFeatured
      email
      logoUrl
      imageUrl
      locationMapUrl
      shareableUrl
      appUrl
      billingAddress
      categories {
        id
        name
      }
      offers(first: 1000, all: true) {
        edges {
          node {
            id
            startDate
            endDate
            ...OfferList_offers
          }
        }
      }
    }
  `,
});

const BrandShow = () => {
  return (
    <StoreProvider
      container={BrandShowContainer}
      modern
      query={graphql`
        query BrandShowQuery($brandId: ID!) {
          brand: store(id: $brandId) {
            ...BrandShow_brand
          }
        }
      `}
    />
  );
};

export default BrandShow;

BrandShowView.propTypes = {
  brand: StorePresenter.shape().isRequired,
  match: PropTypes.shape().isRequired,
};
